import SocialShareLink from './SocialShareLink';

export default SocialShareLink;
